<template>
  <div v-cloak>
    <div class="q_rank" v-if="!loading">
      <div class="q_vertical_left q_pad_tb10px q_bor_top">
        <div class="q_inlineblock">
          <van-image class="q_join_img" fit="cover" :src="convertImg(user.avatar)"/>
        </div>
        <div class="q_mar_l15px q_inlineblock q_con">
          <div class="q_text_m q_bold q_moit1 q_justify" v-text="user.realName">张三</div>
        </div>
        <div class="q_inlineblock q_right q_time">
          <span class="q_text_s q_color_default q_bold" v-text="user.integral + '积分'">50小时</span>
        </div>
      </div>
      <div class="q_vertical_left q_pad_tb10px q_bor_top" v-for="item in userIntegralList"
           v-if="userIntegralList.length>0">
        <div class="q_inlineblock q_name">
          <div class="q_text_m q_bold q_moit1 q_justify" v-if="item.isSign=='1'">每日签到</div>
          <div class="q_text_m q_bold q_moit1 q_justify" v-if="item.isSign=='2'">爱心捐款</div>
          <div class="q_text_m q_bold q_moit1 q_justify" v-if="item.isSign!='1'&&item.isSign!='2'">{{
              item.activityName
            }}
          </div>
          <div class="q_text_s q_color_gray q_mar_t5px">{{ item.createTime }}</div>
        </div>
        <div class="q_inlineblock q_right q_time">
          <span class="q_text_s q_color_default q_bold">{{ '+' + item.score + '积分' }}</span>
        </div>
      </div>
      <!--空数据-->
      <div class="q_center" style="margin-top: 26vh;" v-if="userIntegralList.length==0">
        <img src="@/assets/image/none.png" style="width: 26vw;"/>
        <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
      </div>
    </div>
  </div>
</template>

<script>

import {listIntegral} from "@/api/integral";
import {getUserInfo} from "@/api/user";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Join',
  props: {
    msg: String
  },
  data() {
    return {
      loading:true,
      user: {
        realName: '加载中...',
        integral: 0
      },
      userIntegralList: [],
      userId: undefined
    }
  },
  created() {
    wxCloseShare()
    this.userId = this.$route.query.userId;
    this.init()
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      this.loading = true
      this.$modal.loading()
      let data = {'userId': this.userId, 'pageSize': 99999}
      listIntegral(data).then(res => {
        this.userIntegralList = res.rows
        return getUserInfo(this.userId)
      }).then(res => {
        this.user = res.data
      }).finally(() => {
        this.loading = false
        this.$modal.closeLoading()
      })
    }
  },
}
</script>
<style scoped="scoped">
.q_join_img {
  width: 40px;
  height: 40px;
}

.q_join_img >>> .van-image__img {
  border-radius: 30px;
}

.q_con {
  width: 190px;
}

.q_name {
  width: 245px;
}

.q_time {
  width: 90px;
}

.q_rank {
  padding: 0 15px;
}
</style>
